// src/plugins/nprogress.js
import 'nprogress/nprogress.css'
import NProgress from 'nprogress'
import { useNProgress } from '@vueuse/integrations/useNProgress'

// Configure options via NProgress directly if you want
NProgress.configure({ showSpinner: false, minimum: 0.08, trickleSpeed: 200 })

// useNProgress returns reactive helpers and start/done/remove functions
const { start, done, progress, isLoading, remove } = useNProgress(null, {
  minimum: 0.08,
  showSpinner: false,
  trickleSpeed: 200,
})

// Provide a small wrapper API matching vue-progress-bar naming
export default {
  start,
  finish: done,
  fail: () => {
    // force complete and show failure state quickly
    NProgress.done(true)
  },
  set: (v) => {
    // v is 0..1
    progress.value = v
  },
  isLoading,
  remove,
}
